import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../../../../components/CircledIcon';
import GenericCard from '../../../../components/GenericCards/GenericCards';
import Link from '../../../../components/Link';
import useModal from '../../../../hooks/useModal';
import { ModalManagementStore } from '../../../../providers/modal-manager';
import AnnualEnrollmentMaterialsModal from '../../AnnualEnrollmentMaterialsModal/AnnualEnrollmentMaterialsModal';
import ClaimsReimbursementOtherFormsModal from '../../ClaimsReimbursementOtherFormsModal/ClaimsReimbursementOtherFormsModal';
import DocumentsSummaryModal from '../../DocumentsSummaryModal/DocumentsSummaryModal';
import OtherBenefitsModal from '../../OtherBenefitsModal/OtherBenefitsModal';
import ReferenceMaterialsModal from '../../ReferenceMaterialsModal/ReferenceMaterialsModal';
import RegulatoryNoticesModal from '../../RegulatoryNoticesModal/RegulatoryNoticesModal';
import SummaryBenefitsCoverageModal from '../../SummaryBenefitsCoverageModal/SummaryBenefitsCoverageModal';

const documentsOptions = [
  {
    title: 'Summary Plan Descriptions (SPDs)',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },

  {
    title: 'Annual Enrollment Materials',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },

  {
    title: 'Other Benefits',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },

  {
    title: 'Summary of Benefits & Coverage',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },

  {
    title: 'Regulatory Notices',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },

  {
    title: 'Claims/Reimbursement & Other Forms',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },
  {
    title: 'Reference materials',
    iconR: light('chevron-right'),
    iconCircle: light('folder'),
  },
];

const Documents = () => {
  const { openModal } = useContext(ModalManagementStore);

  const [
    showAnnualEnrollmentMaterialsModal,
    handleShowAnnualEnrollmentMaterialsModal,
    handleCloseAnnualEnrollmentMaterialsModal,
  ] = useModal();

  const [
    showSummaryBenefitsCoverageModal,
    handleShowSummaryBenefitsCoverageModal,
    handleCloseSummaryBenefitsCoverageModal,
  ] = useModal();

  const [
    showOtherBenefitsModal,
    handleShowOtherBenefitsModal,
    handleCloseOtherBenefitsModal,
  ] = useModal();

  const [
    showRegulatoryNoticesModal,
    handleShowRegulatoryNoticesModal,
    handleCloseRegulatoryNoticesModal,
  ] = useModal();

  const [
    showReferenceMaterialsModal,
    handleShowReferenceMaterialsModal,
    handleCloseReferenceMaterialsModal,
  ] = useModal();

  const handleSubmit = (formData: any) => {
    console.log('submit', formData);
  };

  const [
    showDocumentsSummaryModal,
    handleShowDocumentsSummaryModal,
    handleCloseDocumentsSummaryModal,
  ] = useModal();

  const [
    showClaimsReimbursementOtherFormsModal,
    handleShowClaimsReimbursementOtherFormsModal,
    handleCloseClaimsReimbursementOtherFormsModal,
  ] = useModal();

  //references to all show modal functions
  const modalsShowHandlers = [
    handleShowDocumentsSummaryModal,
    handleShowAnnualEnrollmentMaterialsModal,
    handleShowOtherBenefitsModal,
    handleShowSummaryBenefitsCoverageModal,
    handleShowRegulatoryNoticesModal,
    handleShowClaimsReimbursementOtherFormsModal,
    handleShowReferenceMaterialsModal,
  ];

  return (
    <>
      <DocumentsSummaryModal
        showDocumentsSummaryModal={showDocumentsSummaryModal}
        handleCloseDocumentsSummaryModal={handleCloseDocumentsSummaryModal}
      />

      <AnnualEnrollmentMaterialsModal
        showAnnualEnrollmentMaterialsModal={showAnnualEnrollmentMaterialsModal}
        handleCloseAnnualEnrollmentMaterialsModal={
          handleCloseAnnualEnrollmentMaterialsModal
        }
      />

      <OtherBenefitsModal
        showOtherBenefitsModal={showOtherBenefitsModal}
        handleCloseOtherBenefitsModal={handleCloseOtherBenefitsModal}
      />

      <SummaryBenefitsCoverageModal
        showSummaryBenefitsCoverageModal={showSummaryBenefitsCoverageModal}
        handleCloseSummaryBenefitsCoverageModal={
          handleCloseSummaryBenefitsCoverageModal
        }
      />

      <RegulatoryNoticesModal
        showRegulatoryNoticesModal={showRegulatoryNoticesModal}
        handleCloseRegulatoryNoticesModal={handleCloseRegulatoryNoticesModal}
      />

      <ClaimsReimbursementOtherFormsModal
        showClaimsReimbursementOtherFormsModal={
          showClaimsReimbursementOtherFormsModal
        }
        handleCloseClaimsReimbursementOtherFormsModal={
          handleCloseClaimsReimbursementOtherFormsModal
        }
      />

      <ReferenceMaterialsModal
        showReferenceMaterialsModal={showReferenceMaterialsModal}
        handleCloseReferenceMaterialsModal={handleCloseReferenceMaterialsModal}
      />

      <Container className={'px-0'}>
        <Row sm={1} className={'mx-0'}>
          <Col className={'px-0 mx-0 col-lg-8'}>
            <Row className={'row-cols-lg-2 mx-0'}>
              {documentsOptions.map((genericCard, index) => {
                return (
                  <div
                    key={genericCard.title}
                    className={'px-0 pe-lg-7 pe-sm-0'}
                  >
                    <GenericCard className={'p-7 mt-7'} variant={'white'}>
                      <Container
                        className={'d-flex align-items-center px-0'}
                        style={{ maxHeight: 45 }}
                      >
                        <CircledIcon
                          variant="icon-emphasized"
                          icon={genericCard.iconCircle}
                        />
                        <Container className={'w-100 px-0 ms-7'}>
                          <Link
                            onMouseDown={modalsShowHandlers[index]}
                            rightIcon={genericCard.iconR}
                            isBlue
                            isAlignAtEnd
                          >
                            <h6 className="text-fs-6 mb-0 fw-normal">
                              {genericCard.title}
                            </h6>
                          </Link>
                        </Container>
                      </Container>
                    </GenericCard>
                  </div>
                );
              })}
            </Row>
          </Col>

          <Col className={'px-0 col-4 col-lg-4 mt-7'}>
            <GenericCard
              onClick={() => openModal('document-upload')}
              className={'doc-upload p-9 cursor-pointer'}
              variant={'white'}
            >
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}
              >
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company2.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company2.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">Document Upload</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>Easily submit documents</span>
              </div>
            </GenericCard>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Documents;
